<template>
  <el-row style="">
    <div style="background-color: white;padding: 10px; margin-top: 15px">
      <h4>【专业模式】换杆后数据修正</h4>

      <p>上传旧测斜杆的最后一期数据和新测斜杆的第一期数据，并填入生效时间，生效时间之后的数据将被修正</p>

      <el-form ref="form" label-width="80px">

        <!--<el-form-item label="XXXX">-->
        <!--  <el-button type="primary">-->
        <!--    XXXX-->
        <!--  </el-button>-->

        <!--  <el-button type="primary">-->
        <!--    选择文件-->
        <!--    <input type="file" accept=".csv" @change="filechange($event)" style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0"/>-->
        <!--  </el-button>-->
        <!--</el-form-item>-->

        <el-form-item label="模版">
          <el-button size="small" type="default" @click="exportTemplate">导出数据模版</el-button>
        </el-form-item>

        <el-form-item label="数据文件" style="width: 400px">
          <el-upload
                  class="upload-demo"
                  ref="upload"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  accept="csv"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-change="handleChange"
                  :limit="2"
                  :multiple="true"
                  :on-exceed="showMsgOverNumber"
                  :file-list="fileList"
                  :http-request="httpUpload"
                  :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>

            <div slot="tip" class="el-upload__tip">
              请上传两个csv文件；<br>
              第一个文件是旧测斜杆的最后一期数据；<br>
              第二个文件是新测斜杆的第一期数据；<br>
              如果需要更换文件，请先移除之前的文件；<br>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="生效时间">
          <el-date-picker
                  v-model="datetimeValue"
                  type="datetime"
                  placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="httpUpload">上传并修正数据</el-button>
          <el-button size="small" type="danger" @click="showHistory">查看和取消修正</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div>
      <el-dialog
              title="换杆修正历史"
              :visible.sync="dialogVisible"
              width="60%">
        <change-rod-history-table v-if="dialogVisible" :point-id="pointId"></change-rod-history-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" @click="dialogVisible = false">返 回</el-button>
        </span>
      </el-dialog>
    </div>

    <!--<el-form ref="form" :model="form" label-width="80px">-->

    <!--  &lt;!&ndash;读取数据文件 两个 old和new&ndash;&gt;-->
    <!--  <el-form-item>-->

    <!--  </el-form-item>-->
    <!--  <el-form-item>-->
    <!--    <el-button type="primary" @click="submitFiles">立即创建</el-button>-->
    <!--    <el-button>取消</el-button>-->
    <!--  </el-form-item>-->
    <!--</el-form>-->
  </el-row>
</template>

<script>
  import moment from 'moment';
  import ChangeRodHistoryTable from "./changeRodHistoryTable";
  import MD5 from 'js-md5';
  export default {
    name: "changeRod",
    components: {ChangeRodHistoryTable},
    props: {
      'point-id':{
        required: true,
      }
    },
    data () {
      return{
        dialogVisible: false,
        isUploading: false,
        currentFileList: [],
        fileList: [],
        // dateValue: [],
        // timeValue: [],
        datetimeValue: null
          // [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}]
      }
    },
    methods:{
      exportTemplate:function () {
        let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
        this.$http.get('/front/data/exportDeltaTemplate',
          {
            params: {
              userId: this.$store.state.userId,
              pointId:this.pointId,
              auth_userId:this.$store.state.auth_userId,
              auth_timestamp:this.$store.state.auth_timestamp,
              token:MD5(hash),
            },
          }
        ).then(function (res) {
          if(this.browserType == '360'){
            let a = document.getElementById("download");
            a.setAttribute("href", res.url);
            a.setAttribute("target", "view_window");
            this.dialogVisible = true;
          }else {
            window.location.href = res.url;
          }
        }).catch(function (res) {
          this.$message(res.body.msg);
        })
      },
      // handleClose(done) {
      //   this.$confirm('确认关闭？')
      //     .then(_ => {
      //       done();
      //     })
      //     .catch(_ => {});
      // },

      // filechange:function (event) {
      //   this.file = event.target.files[0];
      //   console.log('this.file',this.file)
      // },
      showMsgOverNumber (){
        this.$message.error('只能选择2个文件');
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
        // console.log('handleRemove',[file, fileList]);
      },
      handlePreview(file) {
        // console.log('handlePreview',file);
      },
      handleChange(file, fileList) {
        let _this = this;
        _this.currentFileList = fileList;
        // console.log('handleChange',[file, fileList]);
      },
      // submitFiles(){
      //   let _this = this;
      //   let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
      //
      //   // auth_userId:_this.$store.state.auth_userId,
      //   //   auth_timestamp:_this.$store.state.auth_timestamp,
      //   //   token:_this.calc(hash),
      // },
      httpUpload (params) {
        let _this = this;
        let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
        // console.log('httpUpload',params);
        // console.log('fileList',_this.fileList);
        //
        // console.log('_this.currentFileList',_this.currentFileList);
        // 文件检查
        if(_this.currentFileList.length !== 2){
          _this.$message.error('请选择2个文件');
          return false;
        }
        // 时间检查
        if(!_this.datetimeValue){
          _this.$message.error('请选择生效时间');
          return false;
        }

        // 已经发起请求时，不同时发起请求
        if(_this.isUploading === false){
          _this.isUploading = true;
        }else{
          return false;
        }


        let fd = new FormData();
        fd.append('oldLastFile',_this.currentFileList[0].raw);
        fd.append('newFirstFile',_this.currentFileList[1].raw);
        this.$http.post('/front/data/uploadDelta',
          fd,
          {
            params: {
              pointId: _this.pointId,
              dateString:moment(_this.datetimeValue).format("YYYY-MM-DD HH:mm:ss"),
              userId: _this.$store.state.userId,
              auth_userId:_this.$store.state.auth_userId,
              auth_timestamp:_this.$store.state.auth_timestamp,
              token:MD5(hash),
            },
            headers:{
              'Content-Type':`multipart/form-data;`
              // 'Content-Type':`multipart/form-data;boundary=${new Date().getTime()}`
            },
            // body:{
            //   oldLastFile: _this.currentFileList[0],
            //   newFirstFile: _this.currentFileList[1],
            // }
        }).then(function (res) {
          if(res && res.body.errcode && res.body.errcode === -1){
            // console.log('uploadDelta',res.body.msg);
            _this.$message.error(res.body.msg);
          }else{
            _this.$message.success('修正成功');
          }
        }).catch(function (res) {
          _this.$message.error(res.body.msg);
        }).finally(()=>{
          _this.isUploading = false;
        })
      },
      showHistory () {
        let _this = this;
        _this.dialogVisible = true;
      }
    },
    watch: {
      'fileList':function (newData) {
        // console.log('fileList newData',newData);
      },
      'datetimeValue':function (newData) {
        let _this = this;
        // console.log('datepicker newData',newData);
        // console.log('datepicker str',moment(_this.datetimeValue).format("YYYY-MM-DD HH:mm:ss"));
      }
    }
  }
</script>

<style scoped>

</style>
